import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ContentChildren, QueryList, AfterContentInit, HostListener } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EForsyningFeaturesMitForbrugTileComponent } from "../e-forsyning-features-mit-forbrug-tile/e-forsyning-features-mit-forbrug-tile.component";
import { MatIconModule } from "@angular/material/icon";
import { Subscription, interval } from "rxjs";

@Component({
    selector: "mit-forbrug-carousel",
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: "./mit-forbrug-carousel.component.html",
    styleUrl: "./mit-forbrug-carousel.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MitForbrugCarouselComponent implements AfterContentInit {
    @ContentChildren(EForsyningFeaturesMitForbrugTileComponent) cards!: QueryList<EForsyningFeaturesMitForbrugTileComponent>;

    public cardsArray = [];
    public currentIndex: number = 0;
    private autoplayInterval: number = 5000;
    intervalSubscription!: Subscription;
    cardWidth: number;
    showCarousel: boolean = true;

    constructor(private cdr: ChangeDetectorRef) {}

    @HostListener("mouseover")
    @HostListener("click")
    @HostListener("focus")
    onInteract() {
        //Stop the auto-slide when user interacts
        this.stopAutoSlide();
        this.cdr.markForCheck();
    }

    get isMobile(): boolean {
        return window.innerWidth < 787;
    }

    public ngAfterContentInit() {
        this.cardsArray = this.cards.toArray();

        if (this.cardsArray.length <= 2) {
            this.showCarousel = false;
        }

        if (this.showCarousel || (this.isMobile && this.cardsArray.length > 1)) {
            this.showCarousel = true;
            this.startAutoSlide();
        }
    }

    public startAutoSlide() {
        this.intervalSubscription = interval(this.autoplayInterval).subscribe(() => {
            if (this.currentIndex !== this.cardsArray.length - 1) {
                this.next();
            } else this.currentIndex = 0;
            this.cdr.markForCheck();
        });
    }

    public stopAutoSlide() {
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
        }
    }

    public prev() {
        this.currentIndex = Math.max(this.currentIndex - 1, 0);
    }

    public next() {
        this.currentIndex = Math.min(this.currentIndex + 1, this.cardsArray.length - 1);
    }

    public goToSlide(index: number) {
        this.currentIndex = index;
    }

    // Clean up the subscription when the component is destroyed
    ngOnDestroy() {
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
            this.stopAutoSlide();
        }
    }
}
